export var heights = {
    max: 48,
    min: 40
};
export var paddings = {
    max: {
        1: 56,
        2: 105,
        3: 121,
        4: 201
    },
    min: {
        1: 48,
        2: 88,
        3: 104,
        4: 168
    }
};
//# sourceMappingURL=paddings.js.mapexport var heights = {
    max: 48,
    min: 40
};
export var paddings = {
    max: {
        1: 56,
        2: 105,
        3: 121,
        4: 201
    },
    min: {
        1: 48,
        2: 88,
        3: 104,
        4: 168
    }
};
//# sourceMappingURL=paddings.js.map